import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { ArticleApi } from '../../../network';
import { ArticleModel } from '../../../network/rest';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import './style.scss';

function ArticleDetails() {
    const [data, setData] = useState<ArticleModel | undefined>();
    const { articleId } = useParams();

    useEffect(() => {
        const getData = async () => {
            try {
                if (!articleId) {
                    return;
                }
                const response = await ArticleApi.getArticleApiV1ArticlesArticleGet({
                    id: articleId,
                });
                if (response) {
                    setData(response);
                }
            } catch (e) {
                ApiErrorHandler(e, true);
            }
        };

        getData();
    }, []);

    if (data) {
        const publishedOn = new Date(data.publishOn);
        return (
            <div className="ArticleDetails">
                <span>
                    {data.fileUrl && (
                        <img src={data.fileUrl as unknown as string} alt={data.title} />
                    )}
                </span>
                <h1 className="title">{data.title}</h1>
                <span className="date">{publishedOn.toLocaleDateString('sl')}</span>
                <span className="author">{data.author}</span>
                <div className="content">{data.content ? parse(data.content) : null}</div>
                {data.html ? parse(data.html) : null}
            </div>
        );
    }
    return null;
}

export default ArticleDetails;
